<template lang="pug">
  span.title {{ name }}
</template>

<script>
import { injectRouteState } from '@iez/core'
import { reactive, toRefs, computed } from '@vue/composition-api'

export default {
  setup () {
    const routeState = injectRouteState()

    const state = reactive({
      name: computed(() => routeState.user?.name)
    })

    return {
      ...toRefs(state)
    }
  }
}
</script>
